import { compose, mdsWidget } from 'dojo/_base/declare';

import FinderBaseV2 from '../../FinderBase/FinderBaseV2';
import lang from 'dojo/_base/lang';
import DigitalSignatureEditor from '../DigitalSignatureEditor';
import DS_FileUploadForm from './DS_FileUploadForm/DS_FileUploadForm';

class DigitalSignatureFileFinder extends compose(FinderBaseV2) {

    private _onRowClick(row: StaticTable.StaticTableRow<any>): void {
        let editor = new DigitalSignatureEditor();
        this._addEditorEventListener(editor);
        let entity = row.rowGroup.entity.ref_signature_entity;
        editor.setup(entity, this.getTabContainer());
    }

    private _onClickNew(e: MouseEvent): void {
        let editor = new DS_FileUploadForm();
        this._addEditorEventListener(editor);
        editor.setup();
    }

    private _tableFormatter(cell: StaticTable.StaticTableCell<any>): boolean {
        let name = cell.name;
        let entity = cell.entity;
        let node = cell.tableCellNode;
        let value = cell.value;

        switch (name) {

        }

        return false;
    }

    private _addEditorEventListener(editor: MdsLax<InstanceType<typeof DigitalSignatureEditor>> | MdsLax<InstanceType<typeof DS_FileUploadForm>>): void {
        //editor.on("changed", lang.hitch(this, this.reload));
        editor.on("saved", lang.hitch(this, this.reload));
        editor.on("deleted", lang.hitch(this, this.reload));
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.setupFinderWithCallfunctions(
            "Webtool_API_DigitalSignature__FileFinder_GetFinderConfig",
            "Webtool_API_DigitalSignature__FileFinder_GetFinderResults",
            lang.hitch(this, this._onRowClick),
            lang.hitch(this, this._tableFormatter),
            { neededUserRole: "DigitalSignature_Files", callback: lang.hitch(this, this._onClickNew) });
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(DigitalSignatureFileFinder);